// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "6e2df41/js/" + chunkId + ".js";
};